declare global {
  interface Window {
    version: string;
  }
}

export const version = window.version;
export const isDelegate = location.search.includes('delegate=') || !!sessionStorage.getItem('delegate');
export const isProduction = process.env.NODE_ENV === 'production';
